
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import Content from '../../../../layout/content/Content'
import Head from '../../../../layout/head/Head'
import { getStoreSortItems, updateItemCategoryPositionForStore, updateItemPositionForStore } from '../../../../redux/admin/store/action';
import { useParams } from 'react-router';
import { ColorRing } from 'react-loader-spinner'
import { BlockBetween, BlockDes, BlockHead, BlockHeadContent, BlockTitle, Icon, RSelect } from '../../../../components/Component';
import { Card, Col, Row } from 'antd';
import ToastExample from '../../../../helpers/toast';
import { FormGroup, Input, Label } from 'reactstrap';
import { Controller } from 'react-hook-form';

function SortItems() {
    const { store_id } = useParams();
    const [loading, setLoading] = useState(false);
    const [showToast, setShowToast] = useState(false);

    const [items, setItems] = useState([]);
    const [categories, setCategories] = useState([]);
    const [selectedCategoryId, setSelectedCategoryId] = useState();

    const [dragItemIndex, setDragItemIndex] = useState();
    const [dragOverItemIndex, setDragOverItemIndex] = useState();
    const dispatch = useDispatch();

    useEffect(() => {
        setLoading(true);
        dispatch(getStoreSortItems(store_id)).then((response) => {
            console.log(response.payload, 'response')
            if (response && response.payload && response.payload.success) {
                setLoading(false);
                setItems(response.payload.items)
                setCategories(response.payload.categories)
                setSelectedCategoryId(response.payload.categories[0].id)
            }
        })
    }, [])


    function handleDragStart(index) {
        return function (event) {
            setDragItemIndex(index)
        }
    };

    const handleDragOver = index => {
        return function (event) {
            event.preventDefault();
        }
    };

    const handleDrop = index => {
        return function move(event) {
            event.preventDefault();
            console.log(`Move Item ${dragItemIndex} To Position: ${index}`);
            const _sports = [...items];
            const item = _sports.splice(dragItemIndex, 1)[0];
            item.order_column = index;
            _sports.splice(index, 0, item);
            setItems(_sports);
        }
    };

    const updateSortBtn = () => {
        dispatch(updateItemPositionForStore(items))
        setShowToast(true);
        setTimeout(() => {
            setShowToast(false);
        }, 3000);
    };


    // for the next position
    const handleDragEnter = index => {
        return (event) => {
            setDragOverItemIndex(index);
            console.log("New Position: ", index, event)
        }
    }

    const handleDragLeave = index => {
        return event => {
            setDragOverItemIndex(undefined)
        }
    };

    const handleDragEnd = (event) => {
        setDragItemIndex(undefined);
        setDragOverItemIndex(undefined);
    };

    const changeCategory = (e) => {
        setSelectedCategoryId(e.target.value)
    };


    return (
        <React.Fragment>
            <Head title="Store Item Categories"></Head>
            {loading ?
                <Content >
                    <div className='d-flex align-items-center justify-content-center' style={{ minHeight: '75vh' }}>
                        <ColorRing
                            visible={true}
                            height="80"
                            width="80"
                            ariaLabel="blocks-loading"
                            wrapperStyle={{}}
                            wrapperClass="blocks-wrapper"
                            colors={['#fcc314', '#fcc314', '#fcc314', '#fcc314', '#fcc314']}
                        />
                    </div>
                </Content>
                :
                <React.Fragment>
                    <Head title="Sort Items"></Head>

                    <Content>
                        <BlockHead size="sm">
                            <BlockBetween>
                                <BlockHeadContent>
                                    <BlockTitle tag="h3" page>
                                        Sort Items
                                    </BlockTitle>
                                    <BlockDes className="text-soft">
                                        {/* <p>You have total {sports.length} stores.</p> */}
                                    </BlockDes>
                                </BlockHeadContent>
                                <BlockHeadContent>
                                    <ToastExample show={showToast} />
                                </BlockHeadContent>
                            </BlockBetween>
                        </BlockHead>

                        <FormGroup className='mb-3' row>
                            <Label for="exampleSelect" sm={2}  >
                                Select Item Category:
                            </Label>
                            <Col sm={10}>
                                <Input id="exampleSelect" name="select" type="select" onClick={(e) => { changeCategory(e) }}>
                                    {categories.map((category) => (
                                        <option value={category.id} selected={selectedCategoryId === category.id}>  {category.name}  </option>
                                    ))}
                                </Input>
                            </Col>
                        </FormGroup>
                        <Card>
                            {items.length > 0 ?
                                <Row>
                                    <Col span={24}>
                                        <ui className="no-category-bullets">
                                            {items.map((item, index) => (
                                                item.item_category_id == selectedCategoryId ?
                                                    <li
                                                        key={index}
                                                        className={dragOverItemIndex === index ? "list-category new-position" : "list-category"}
                                                        draggable
                                                        onDragStart={handleDragStart(index)}
                                                        onDragOver={handleDragOver(index)}
                                                        onDrop={handleDrop(index)}
                                                        onDragEnter={handleDragEnter(index)}
                                                        onDragLeave={handleDragLeave(index)}
                                                        onDragEnd={handleDragEnd}
                                                    >
                                                        <span className='text-left'>  <Icon name="menu" /></span>
                                                        <span>{item.name}</span>
                                                    </li>
                                                    : null
                                            ))}
                                        </ui>
                                    </Col>
                                </Row>
                                :
                                <div>
                                    No Items
                                </div>
                            }
                        </Card>
                        <div className='mt-4 text-right w-100'>
                            <button className='btn btn-lg btn-success' onClick={() => { updateSortBtn() }}>
                                Apply
                            </button>
                        </div>
                    </Content>
                </React.Fragment>
            }
        </React.Fragment>
    )
}

export default SortItems
